import React, { useEffect, useState } from 'react';
import TableGuttmanChart from './Table';
import Filter, { renderElementLC } from './Filter';
import { useSelector } from 'react-redux';

const GuttmanChart = () => {
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const completed = useSelector((state) => state?.classMarking.guttmanChartType);
  const completedType = completed === 'completedTeacher' ? 'completedTeacherValue' : 'completedStudentValue';

  const ullcs = useSelector((state) =>
    JSON.parse(
      JSON.stringify(
        state?.class?.unitOfLearning?.lcs.map((lc) => {
          return {
            ...lc,
            curriculumelements: renderElementLC(lc, currentCurriculum)
          };
        }) || []
      )
    )
  );
  const ulstudents = useSelector((state) => JSON.parse(JSON.stringify(state?.classMarking?.students || [])));
  const loading = useSelector((state) => state?.classMarking?.studentsLoading);

  const [filter, setFilter] = useState({});
  const [lcs, setLcs] = useState(ullcs);
  const onFilter = (key, name, value) => {
    const newFilter = { ...filter };
    if (Array.isArray(value)) {
      if (value.length === 0) {
        delete newFilter[key][name];
      } else if (value.includes('')) {
        delete newFilter[key][name];
      } else {
        if (newFilter[key]) {
          newFilter[key][name] = value;
        } else {
          newFilter[key] = {
            [name]: value
          };
        }
      }
    } else {
      if (newFilter[key]) {
        newFilter[key][name] = value;
      } else {
        newFilter[key] = {
          [name]: value
        };
      }
    }
    setFilter(newFilter);
    const nlcs = ullcs.filter((lc) => filterdata(newFilter, lc, key, name));
    setLcs(nlcs);
  };

  const filterdata = (filter, lc, keyFilter, nameFilter) => {
    let valid = true;
    for (const key in filter) {
      if (key === 'lcElements') {
        Object.keys(filter[key]).forEach((name) => {
          if (keyFilter === key && nameFilter === name) {
            return true;
          }
          if (!filter?.lcElements?.[name].includes(lc?.lcElements?.[name])) {
            valid = false;
          }
        });
      }
      if (key === 'curriculumelements') {
        Object.keys(filter[key]).forEach((name) => {
          if (keyFilter === key && nameFilter === name) {
            return true;
          }
          if (!filter?.curriculumelements?.[name].includes(lc?.curriculumelements?.[name])) {
            valid = false;
          }
        });
      }
    }
    return valid;
  };

  return (
    <div>
      <div className='absolute left-0 right-0 top-0 h-16 overflow-auto'>
        <Filter filter={filter} onFilter={onFilter} lcs={lcs} />
      </div>
      <div className='absolute left-0 right-0 bottom-0 top-18 overflow-auto'>
        <TableGuttmanChart
          loading={loading}
          lcs={ullcs.filter((lc) => filterdata(filter, lc))}
          completedType={completedType}
          completed={completed}
          students={ulstudents.map((student) => {
            const studentLcs = student?.lcs
              ?.map((lc) => {
                const granularSteps =  lc.granularSteps.filter((gs) => gs.isLevel)
                return {
                  ...lc,
                  granularSteps,
                  completedTeacherValue: granularSteps?.reduce((acc, step) => acc + step?.completedTeacherValue, -1),
                  completedStudentValue: granularSteps?.reduce((acc, step) => acc + step?.completedStudentValue, -1),
                  curriculumelements: renderElementLC(lc, currentCurriculum)
                };
              })
              ?.filter((lc) => filterdata(filter, lc));

            return {
              ...student,
              lcs: studentLcs,
              completedTeacherValue: studentLcs?.reduce((acc, step) => acc + step?.[completedType], -1),
              completedStudentValue: studentLcs?.reduce((acc, step) => acc + step?.[completedType], -1),
              [completedType]: studentLcs?.reduce((acc, step) => acc + step?.[completedType], -1)
            };
          })}
        />
      </div>
    </div>
  );
};

export default GuttmanChart;
